import React, { useCallback, useContext, useEffect, useState } from "react";
import "./index.less";
import CardList from "../../components/KnowledgeCardList";
import { ContextMenuMode } from "../../types";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import ShortcutPopover from "../KnowledgeShortcut/Popover";
import api from "../../api";
import { createPageUrl } from "../../util";
import events from "../../context/events";

const KnowledgeList = (props: any) => {
  const { onLine, focusSDK, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const urlPrefix = appRuntimeEnv.joyspaceHost;

  useEffect(() => {
    getKnowledgeList();
  }, []);

  const getKnowledgeList = () => {
    setLoading(true);
    api.pages
      .getFileList("kl")
      .then((data) => {
        if (data) {
          setList(data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    events.on("wiki:refreshList", getKnowledgeList);
    return () => {
      events.off("wiki:refreshList", getKnowledgeList);
    };
  }, []);

  const openLink = useCallback(
    (url: string, target: string) => {
      focusSDK.printLog("joyspace: 打开知识库 before：", url);
      try {
        window.open(url, target);
      } catch (e) {
        focusSDK.printLog("joyspace: 打开知识库 error：", e);
      }
      focusSDK.printLog("joyspace: 打开知识库 end：", url);
    },
    [focusSDK]
  );

  const openKnowledge = useCallback((e, item) => {
    openLink(createPageUrl(item, urlPrefix), "_blank");
  }, []);

  return (
    <CardList
      list={list}
      loading={loading}
      callback={openKnowledge}
      // renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
      //   // if (!item.id) {
      //   //   return <span />;
      //   // }
      //   return (
      //     <ShortcutPopover
      //       contextMenuMode={contextMenuMode}
      //       offlineDisabled={!onLine}
      //       isShortcut={item.isShortcut}
      //       callback={(action: string) => {
      //         // if (action === "setting") {
      //         // }
      //       }}
      //     />
      //   );
      // }}
    />
  );
};

export default KnowledgeList;
